import { render, staticRenderFns } from "./ExpansionItem.vue?vue&type=template&id=6ac808ac&scoped=true"
import script from "./ExpansionItem.vue?vue&type=script&lang=js"
export * from "./ExpansionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac808ac",
  null
  
)

export default component.exports